import * as actionTypes from './actionTypes';

export const showErrorModal = (name, message = '') => ({
  type: actionTypes.SHOW_MODAL,
  name,
  message,
});

export const handleError = (error) => ({
  type: actionTypes.ERROR,
  error,
});
